export default "__VITE_ASSET__B3Eu1h6L__"